import { Chip } from "@mui/material";
import { UserModel } from "services/organizationPortalClient";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { UserStatusType } from "types/userStatusTypes";

export default function StatusChip({ value }: { value: UserModel }) {
  const color =
    value.statusTypeName === UserStatusType.Active
      ? "success"
      : value.statusTypeName === UserStatusType.Inactive
      ? "secondary"
      : "warning";

  return (
    <Chip
      label={value.statusTypeName}
      size="small"
      variant="outlined"
      icon={<FiberManualRecordIcon />}
      color={color}
    />
  );
}
